var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.openModal}},[_c('div',[(!_vm.innerText)?_c('img',{staticClass:"btn",attrs:{"src":"/edit_icon.svg","width":"24px"}}):_c('p',{staticClass:"custom_message",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.innerText))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }